import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { ReplacementTransportPlan } from "@rumble-it/common-lib/types/models/ReplacementTransportPlan.interface";
import { EyeOutlined } from "@ant-design/icons";

export const replacementTransportPlanColumns: TableColumnsType<ReplacementTransportPlan> =
  [
    {
      title: "Opdrachtgever",
      dataIndex: "company.fullName",
      key: "company",
      render: (_text: string, record: ReplacementTransportPlan) => (
        <Link to={`/replacement-transport/plans/${record.id}`}>
          {record.company?.fullName ?? "Algemeen"}
        </Link>
      ),
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: any, record) => (
        <Link to={`/replacement-transport/plans/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];
